import * as React from 'react';
import type { SVGProps } from 'react';
const SvgGoldMedal = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={28}
    height={30}
    fill='none'
    {...props}
  >
    <path
      fill='#FFCE27'
      d='M21.275 24.443a1 1 0 0 1-1.44.831l-6.494-3.196a1 1 0 0 1-.058-1.764l6.973-4.026a1 1 0 0 1 1.498.932z'
    />
    <path
      fill='#FFCE27'
      d='M5.8 24.443a1 1 0 0 0 1.44.831l6.494-3.196a1 1 0 0 0 .059-1.764l-6.974-4.026a1 1 0 0 0-1.498.932z'
    />
    <rect width={18} height={18} x={4.538} y={3} fill='#F8DB45' rx={9} />
    <rect
      width={18}
      height={18}
      x={4.538}
      y={3}
      stroke='#FFCE27'
      strokeWidth={2}
      rx={9}
    />
    <path
      fill='#A37907'
      d='M13.532 16V9.033h-.106l-2.103 1.483V9.098l2.209-1.553h1.506V16z'
    />
    <path
      fill='#FFEA7C'
      d='m17.387 5.64-.866-.384-1.152-.358-.338.27-.035.383.212.407.275.233.717.298.638.342.55.36.495.382.558.502.462.678.29.39.424.12.276-.168v-.699l-.276-.488-.424-.75-.233-.406-.584-.49-.583-.411z'
    />
  </svg>
);
export default SvgGoldMedal;
